import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "./authinterceptor";
import AuthHeader from "../services/auth.header";

export const getOrdersForSubsite = createAsyncThunk('orders/getOrdersForSubsite', async (filter) => {
  console.log("RANGE", filter);
    try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/orders?range=[" + filter[1] + "," + filter[2] + "]&filter=" + filter[0], { headers: AuthHeader.authHeader()});
        return {data: response.data, count: response.headers["total-items"]};
    } catch (error) {
        console.log(error);
    }    
  });

  export const cancelOrder = createAsyncThunk('orders/cancelOrder', async (orderId) => {
    try {
        const response = await axios.delete(process.env.REACT_APP_API_URL + "/admin/order/cancel/" + orderId, { headers: AuthHeader.authHeader()});
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const approveOrder = createAsyncThunk('orders/approveOrder', async (orderId) => {
    try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/order/approve/" + orderId, { headers: AuthHeader.authHeader()});
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const allOrders = state => state.orders.orders;
  export const orderCount = state => state.orders.orderCount;

  const initialState = {
    orders: [],
    orderCount: 0,
    approveStatus: 'idle',
    cancelStatus: 'idle',
    status: 'idle',
    error: null
  };

  const ordersSlice = createSlice({
    name: 'orders',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
          .addCase(getOrdersForSubsite.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getOrdersForSubsite.fulfilled, (state, action) => {
            state.status = 'succeeded'
            state.orders = action.payload.data;
            state.orderCount = action.payload.count;
          })
          .addCase(getOrdersForSubsite.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
          })
          .addCase(cancelOrder.pending, (state, action) => {
            state.cancelStatus = 'loading'
          })
          .addCase(cancelOrder.fulfilled, (state, action) => {
            state.cancelStatus = 'succeeded';
            var idxToRemove = -1;
            for(var i=0; i<state.orders.length; i++) {
              if(state.orders[i].id === action.payload.orderId) {
                idxToRemove = i;
                break;
              }
            }
            state.orders.splice(idxToRemove, 1);
            state.status = 'idle';
          })
          .addCase(cancelOrder.rejected, (state, action) => {
            state.cancelStatus = 'failed';
            state.error = action.error.message;
          })
          .addCase(approveOrder.pending, (state, action) => {
            state.approveStatus = 'loading'
          })
          .addCase(approveOrder.fulfilled, (state, action) => {
            state.approveStatus = 'succeeded';
            state.status = 'idle';
            var idxToRemove = -1;
            for(var i=0; i<state.orders.length; i++) {
              if(state.orders[i].id === action.payload.orderId) {
                idxToRemove = i;
                break;
              }
            }
            state.orders.splice(idxToRemove, 1);
            console.log(action.payload);
          })
          .addCase(approveOrder.rejected, (state, action) => {
            state.approveStatus = 'failed';
            state.error = action.error.message;
          })
      }
  });
  
  export default ordersSlice.reducer;




